import { useCurrentEvent } from "../firebase/firebase"
import { getCurrentOnCall } from "../Integrations/WhenToWork";
import styles from './home-style.module.css'


export default function AtAGlance() {
    const event = useCurrentEvent();
    getCurrentOnCall().then((data) => console.log(data));
    
    

    return (
        <div>
            <h1>At A Glance</h1>
            <p>Current Event: {event?.name}</p>
            {
                event?.matrix_link != null ?
                <a className="interconnect-button" href={event?.matrix_link} target="_blank">Link to Matrix</a>
                : null
            }
        </div>
    )
}